module.exports = __webpack_public_path__ + "static/img/C2.9be83299.jpg";